import { render, staticRenderFns } from "./UserReleaseCommitment.vue?vue&type=template&id=359ba591&scoped=true"
import script from "./UserReleaseCommitment.vue?vue&type=script&lang=js"
export * from "./UserReleaseCommitment.vue?vue&type=script&lang=js"
import style0 from "./UserReleaseCommitment.vue?vue&type=style&index=0&id=359ba591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ba591",
  null
  
)

export default component.exports